import { Injectable } from '@angular/core';
import { AGUAppSurfaceConfig, AGUUrlSyncedHostAdapter } from 'agu_app_shell';

/**
 * Body class that puts MJExplorer into "immersive Research Accelerator" mode —
 * apps/MJExplorer/src/styles.scss hangs the shell-chrome-hiding rules off it via
 * the shared immersive-surface mixin. DERIVED state, recomputed from on-screen
 * truth; the adapter drops it eagerly on sign-out/return so the shell chrome
 * reappears without waiting for the next recompute signal.
 */
export const RA_IMMERSIVE_BODY_CLASS = 'agu-immersive';

/** Element selector the immersive predicate measures for this surface. */
export const RA_SURFACE_SELECTOR = 'mj-agu-surface';

/**
 * MJ Application names served by this one surface.
 *
 * All four are the same DriverClass with different compositions, so all four are
 * "our own app" for the purposes of "Back to Explorer" — offering a user in Grant
 * Finder a link to Grant Finder would change the URL and nothing else.
 *
 * These are Application NAMES, matching metadata/applications/*.json. Adding a
 * fifth composition means adding its name here; that is the one code touch a new
 * app needs, and leaving it out only costs a redundant nav target, never access.
 */
export const RA_APPLICATION_NAMES: readonly string[] = [
    'Research Accelerator',
    'Grant Finder',
    'People Finder',
    'Job Finder',
];

export const RA_SURFACE_CONFIG: AGUAppSurfaceConfig = {
    SurfaceSelector: RA_SURFACE_SELECTOR,
    ImmersiveBodyClass: RA_IMMERSIVE_BODY_CLASS,
    OwnApplicationNames: RA_APPLICATION_NAMES,
};

/**
 * The Research Accelerator's host adapter.
 *
 * A named subclass rather than a bare `AGUAppSurfaceHostAdapter` provider so DI
 * has a stable, greppable token and so future surface-specific behavior has an
 * obvious home.
 *
 * The URL mirroring it relies on lives in the shared `AGUUrlSyncedHostAdapter`
 * (packages/AGUAppShell), which documents the MJ shell defect it works around.
 */
@Injectable()
export class ExplorerRaHostAdapter extends AGUUrlSyncedHostAdapter {}
